<template>
  <div class="site-footer relative">
    <div class="footer-inner bg-bg-4">
      <div class="container container-xl padding-xl-vertical">
        <div
          class="footer-main content flex-wrap m:flex-nowrap gap-2xl flex-center">
          <div class="logo-container">
            <img
              class="logo-image"
              :src="getDynamicAssetUrl('core/images/logos/logo.png')"
              :alt="t('ag.footer.logoAlt')"
              @click="$router.push({ name: 'index' })" />
          </div>
          <!--width-expand-->
          <div
            class="footer-navigation flex-center m:gap-l l:gap-2xl flex-wrap">
            <nav class="footer-nav min-width-150">
              <ul class="unstyled-list">
                <li>
                  <h3>{{ tu("ag.footer.nav.content") }}</h3>
                </li>
                <li>
                  <saffron-link
                    :to="{ name: 'index' }"
                    class="strict-active-visual">
                    <span>{{ tu("ag.footer.nav.home") }}</span>
                  </saffron-link>
                </li>
                <li>
                  <saffron-link :to="{ name: 'content-article', params: {} }">
                    <span>{{ tu("ag.footer.nav.articles") }}</span>
                  </saffron-link>
                </li>
                <li>
                  <saffron-link :to="'/'">
                    <span>{{ tu("ag.footer.nav.store") }}</span>
                  </saffron-link>
                </li>
                <li>
                  <saffron-link :to="{name: 'content-link-alias', params: {alias: 'general'}}">
                    <span>{{ tu("ag.footer.nav.links") }}</span>
                  </saffron-link>
                </li>
              </ul>
            </nav>
            <nav class="footer-nav min-width-150">
              <ul class="unstyled-list">
                <li>
                  <h3>{{ tu("ag.footer.nav.general") }}</h3>
                </li>
                <li>
                  <saffron-link :to="{ name: 'content-term', params: {} }">
                    <span>{{ tu("ag.footer.nav.terms") }}</span>
                  </saffron-link>
                </li>
                <li>
                  <a href="#" @click.prevent.stop="startNewsletterRegistration">
                    <span>{{ tu("ag.footer.nav.newsletter") }}</span>
                  </a>
                </li>
                <li>
                  <saffron-link
                    :to="{
                      name: 'content-article-articleAlias',
                      params: { articleAlias: 'tos' },
                    }">
                    <span>{{ tu("ag.footer.nav.tos") }}</span>
                  </saffron-link>
                </li>
                <li>
                  <saffron-link
                    :to="{
                      name: 'content-article-articleAlias',
                      params: { articleAlias: 'about-us' },
                    }">
                    <span>{{ tu("ag.footer.nav.about") }}</span>
                  </saffron-link>
                </li>
                <li>
                  <saffron-link
                    :to="{
                      name: 'content-article-articleAlias',
                      params: { articleAlias: 'english' },
                    }">
                    <span>{{ tu("ag.footer.nav.english") }}</span>
                  </saffron-link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div
          class="footer-contact-info text-center flex-center flex-wrap gap-m margin-xl-top width-expand">
          <a class="ltr" href="tel:9725483928">(+972) 3-555-5555</a>
          <span>&middot;</span>
          <a class="ltr" href="">info@agaloola.com</a>
          <span>&middot;</span>
          <span>רחוב הבונים 22, תל אביב, ישראל</span>
        </div>
        <div
          class="footer-legal margin-l-top flex-center width-expand text-center">
          2023 © עגלולה. כל הזכויות שמורות.
        </div>
      </div>
    </div>
    <news-letter-registration
      ref="newsLetterRegistrationComponent"></news-letter-registration>
  </div>
</template>

<script>
import NewsLetterRegistration from "@/client/applications/agaloola/components/etc/NewsLetterRegistration.vue";

export default {
  components: {
    NewsLetterRegistration,
  },
  data: function () {
    return {};
  },
  methods: {
    startNewsletterRegistration(modalErrorText = undefined) {
      this.$refs["newsLetterRegistrationComponent"].startNewsletterRegistration(
        modalErrorText
      );
    },
  },
};
</script>

<style scoped lang="scss">
.site-footer {
  overflow-x: hidden;
}
.footer-inner {
  position: relative;
  width: calc(100% + 4px);
  inset-inline-start: -2px;
  border-top: 2px solid var(--c-gray-4);
  border-inline: 2px solid var(--c-gray-4);
  border-start-start-radius: var(--border-radius-l);
  border-start-end-radius: var(--border-radius-l);
}

.logo-container {
  @media (max-width: 767px) {
    flex: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.footer-nav {
  @media (max-width: 767px) {
    text-align: center;
    justify-content: center;
    margin-bottom: var(--margin-l);
  }

  ul {
    li {
      h3 {
        margin-bottom: var(--margin-l);
        font-size: var(--font-l);
        @media (max-width: 767px) {
          margin-bottom: var(--margin-m);
        }
      }

      a {
        color: var(--c-text);

        &:hover {
          text-decoration: none;
          color: var(--c-lead);
        }
      }
    }
  }
}
</style>
